import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-cartas',
  templateUrl: './main-cartas.component.html',
  styleUrls: ['./main-cartas.component.css']
})
export class MainCartasComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
